import { render, staticRenderFns } from "./CheckoutPaymentMethodItem.vue?vue&type=template&id=2f4f6066&scoped=true"
import script from "./CheckoutPaymentMethodItem.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentMethodItem.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPaymentMethodItem.vue?vue&type=style&index=0&id=2f4f6066&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f6066",
  null
  
)

export default component.exports